"use strict";

/**
 * This port handles the relative paths of files
 * that are uploaded to the system, allowing to preserve
 * the original directory structure from the client.
 */

class FileRegistry {
  constructor() {
    this.reset();
  }

  reset() {
    this.filePaths = new WeakMap();
    this.filesByNameAndSize = new Map();
  }

  _generateKey(file) {
    return `${file.name}:${file.size}`;
  }

  addFiles(files) {
    this.reset();
    for (const file of files) {
      this.filePaths.set(file, file.webkitRelativePath || file.name);

      const key = this._generateKey(file);
      if (!this.filesByNameAndSize.has(key)) {
        this.filesByNameAndSize.set(key, []);
      }
      this.filesByNameAndSize.get(key).push({ file, assigned: false });
    }
  }

  getFilePath(fileInfo) {
    const key = this._generateKey(fileInfo);
    const candidateFiles = this.filesByNameAndSize.get(key) || [];

    const nextAvailableFile = candidateFiles.find((item) => !item.assigned);

    if (nextAvailableFile) {
      nextAvailableFile.assigned = true;
      const originalFilePath = this.filePaths.get(nextAvailableFile.file);
      return [fileInfo.name, originalFilePath, fileInfo.size];
    } else {
      return [fileInfo.name, "", fileInfo.size];
    }
  }
}

const setup = (registry) => {
  const handleFileChange = function (event) {
    if (event.target.type === "file") {
      const files = event.target.files || [];
      registry.addFiles(files);
    }
  };

  document.addEventListener("change", handleFileChange, true);
};

const FilePathsPort = {
  add: function (app) {
    const registry = new FileRegistry();
    setup(registry);

    app.ports.getFilePath.subscribe(function (fileInfo) {
      app.ports.receiveFilePath.send(registry.getFilePath(fileInfo));
    });
  },
};

module.exports = FilePathsPort;
